import { useMemo } from 'react'

type UseButtonStyleProps = {
  size?: 's' | 'm' | 'l'
  full?: boolean
  fill?: boolean
  gold?: boolean
  square?: boolean
  simple?: boolean
  simpleselected?: boolean
  thin?: 'gold' | 'pink' | 'gray' | 'none'
  arrow?: 'bottom' | 'left' | 'top' | 'right'
}

export const useButtonStyle = ({
  size,
  full,
  fill,
  gold,
  square,
  simple,
  simpleselected,
  thin,
  arrow,
}: UseButtonStyleProps) => {
  const buttonSizeStyle = useMemo(() => {
    switch (size) {
      case 's':
        return 'sq-btn-size-s'
      case 'l':
        return 'sq-btn-size-l'
      default:
        return ''
    }
  }, [size])

  const widthFullStyle = useMemo(() => {
    switch (full) {
      case true:
        return 'w-full'
      default:
        return ''
    }
  }, [full])

  const backgroundFillStyle = useMemo(() => {
    switch (fill) {
      case true:
        return 'sq-btn-fill'
      default:
        return ''
    }
  }, [fill])

  const colorGoldStyle = useMemo(() => {
    switch (gold) {
      case true:
        return 'sq-btn-gold sq-btn-fill'
      default:
        return ''
    }
  }, [gold])

  const roundedSquareStyle = useMemo(() => {
    switch (square) {
      case true:
        return 'sq-btn-square'
      default:
        return ''
    }
  }, [square])

  const simpleStyle = useMemo(() => {
    switch (simple) {
      case true:
        return 'sq-btn-simple'
      default:
        return ''
    }
  }, [simple])

  const simpleSelectedStyle = useMemo(() => {
    switch (simpleselected) {
      case true:
        switch (simple) {
          case true:
            return 'sq-btn-simple-selected'
          default:
            return ''
        }
      default:
        return ''
    }
  }, [simple, simpleselected])

  const thinStyle = useMemo(() => {
    switch (thin) {
      case 'gold':
        return 'sq-btn-thin-gold sq-btn-square'
      case 'pink':
        return 'sq-btn-thin-pink sq-btn-square'
      case 'gray':
        return 'sq-btn-thin-g75 sq-btn-square'
      case 'none':
        return ''
      default:
        return ''
    }
  }, [thin])

  const arrowDirectionStyle = useMemo(() => {
    switch (arrow) {
      case 'left':
        return 'flex-row'
      default:
        return 'flex-row-reverse'
    }
  }, [arrow])

  return {
    buttonSizeStyle,
    widthFullStyle,
    backgroundFillStyle,
    colorGoldStyle,
    roundedSquareStyle,
    simpleStyle,
    simpleSelectedStyle,
    thinStyle,
    arrowDirectionStyle,
  }
}

export default useButtonStyle
